<div *ngIf="searchParams" class="no-scroll-wrapper">
  <p-table
    [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [lazy]="true"
    [totalRecords]="searchResult?.TotalCount"
    [currentPage]="searchResult?.PageNumber"
    (onLazyLoad)="lazyLoad($event)"
    [lazyLoadOnInit]="false"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="fs-12px">
        <th>
          <p-checkbox binary="true" [(ngModel)]="selectAll" (onChange)="onSelectAllChange()"></p-checkbox>
        </th>
        <th>
          {{ 'revenue.journal-entry-details.transaction-type' | translate | titlecase }}
        </th>
        <th pSortableColumn="InvoiceNum">
          {{ 'revenue.journal-entry-details.invoice-num' | translate | titlecase }}
          <p-sortIcon field="InvoiceNum"></p-sortIcon>
        </th>
        <th pSortableColumn="ApplyDate">
          {{ 'revenue.journal-entry-details.apply-date' | translate | titlecase }}
          <p-sortIcon field="ApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="TranAmount">
          {{ 'revenue.journal-entry-details.amount' | translate | titlecase }}
          <p-sortIcon field="TransactionAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="DebitAccount">
          {{ 'revenue.journal-entry-details.debit-account' | translate | titlecase }}
          <p-sortIcon field="DebitAccount"></p-sortIcon>
        </th>
        <th pSortableColumn="CreditAccount">
          {{ 'revenue.journal-entry-details.credit-account' | translate | titlecase }}
          <p-sortIcon field="CreditAccount"></p-sortIcon>
        </th>
        <th *ngIf="!hideClassColumn">
          {{ 'revenue.journal-entry-details.class-type' | translate | titlecase }}
        </th>
        <th pSortableColumn="OriginalTranCode">
          {{ 'revenue.journal-entry-details.transaction-code' | translate | titlecase }}
          <p-sortIcon field="Descr"></p-sortIcon>
        </th>
        <th pSortableColumn="Asf">
          {{ 'revenue.journal-entry-details.profile' | translate | titlecase }}
          <p-sortIcon field="Asf"></p-sortIcon>
        </th>
        <th pSortableColumn="TranId">
          {{ 'revenue.journal-entry-details.transaction-id' | translate | titlecase }}
          <p-sortIcon field="TranId"></p-sortIcon>
        </th>
      </tr>
      <tr class="fs-12px">
        <th></th>
        <th>
          <p-select
            [options]="transactionTypes"
            [(ngModel)]="searchParams.TranType"
            appendTo="body"
            showClear
            placeholder="{{ 'revenue.post-transactions.post-transactions-search.transactionType' | translate | titlecase }}"
            (onChange)="lazySearch()"
          ></p-select>
        </th>
        <th>
          <input
            pInputText
            type="text"
            styleClass="p-column-filter"
            [(ngModel)]="searchParams.InvoiceNum"
            (input)="lazySearch()"
            style="font-size: 12px; width: 77px"
          />
        </th>
        <th>
          <wl-date-selector
            name="endDate"
            [(ngModel)]="searchParams.ApplyDateFilter"
            (onDateChanged)="lazySearch()"
            [inputStyle]="{ 'font-size': '12px' }"
          ></wl-date-selector>
        </th>
        <th class="w-8"></th>
        <th *ngIf="!hideClassColumn"></th>
        <th></th>
        <th></th>
        <th></th>
        <th>
          <input pInputText type="text" styleClass="p-column-filter" [(ngModel)]="searchParams.SmartProfileFilter" (input)="lazySearch()" />
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction>
      <tr class="fs-12px" [ngClass]="{ 'accounting-package-mismatch': transaction.HasAccountingPackageMismatch }">
        <td>
          <p-checkbox binary="true" [ngModel]="itemIsSelected(transaction)" (ngModelChange)="onRowSelectionChange(transaction)">
          </p-checkbox>
        </td>
        <td>
          {{ transaction.TranType }}
        </td>
        <td>
          {{ transaction.InvoiceNum }}
        </td>
        <td>
          <div class="mct-flex mct-justify-end mct-items-stretch">
            {{ transaction.ApplyDate | date: 'M/d/yyyy' }}
          </div>
        </td>
        <td>
          <div class="mct-flex mct-justify-end mct-items-stretch">
            {{ transaction.TranAmount | currency }}
          </div>
        </td>

        <td style="min-width: 200px" [ngClass]="{ 'missing-account': !transaction.DebitAccount }">
          <p-select
            [placeholder]="'revenue.post-transactions.post-transactions-search.select-account' | translate | titlecase"
            [style]="{ width: '100%' }"
            [options]="accountSelectItems"
            [(ngModel)]="transaction.DebitAccount"
            appendTo="body"
            (onChange)="changeAccount(transaction)"
          ></p-select>
        </td>
        <td style="min-width: 200px" [ngClass]="{ 'missing-account': !transaction.CreditAccount }">
          <div>
            <p-select
              [placeholder]="'revenue.post-transactions.post-transactions-search.select-account' | translate | titlecase"
              [style]="{ width: '100%' }"
              [options]="accountSelectItems"
              [(ngModel)]="transaction.CreditAccount"
              appendTo="body"
              (onChange)="changeAccount(transaction)"
            ></p-select>
          </div>
        </td>
        <td *ngIf="!hideClassColumn">
          {{ transaction.ClassTypeName }}
        </td>
        <td>
          {{ transaction.OriginalTranCode }}
        </td>
        <td>({{ transaction.ProfileId }}) {{ transaction.Asf }}</td>
        <td>
          {{ transaction.TranId }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <a [hidden]="hideShowAll" (click)="showAll()">{{ 'common.page-size.show-all' | translate | titlecase }}</a>
    </ng-template>
    <ng-template pTemplate="paginatorright"> </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
</div>
